var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"notice"},[_c('div',{staticStyle:{"flex":"2","margin":"0 20px 0 0"}},[_c('div',{staticStyle:{"background":"#ffffff"}},[_c('div',{staticClass:"title",staticStyle:{"overflow":"hidden","padding":"8px"}},[_c('span',[_vm._v("登录成功")])])])])])])
}]

export { render, staticRenderFns }